/* eslint-disable */
import { CommonGet } from '../../../helpers/HttpClient';

export default {
    getYesterdayOrderCountSKU,
    getYesterdayOrderCountQty,
    GetTodayOrderCount,
    GetReturnOrderCountToVPUDashboard,
    GetDemandSKUwiseVPUDashboard,
    GetSupplyVCCwiseVPUDashboard,
    GetSupplySKUwiseVPUDashboard,
    GetDemandVCCwiseVPUDashboard
};

async function getYesterdayOrderCountSKU() {
    const response = await CommonGet('/api/VPUDashboard/GetYesterdayOrderCountSKUwiseForVPUDashboard', null);
    return response.data;
}

async function getYesterdayOrderCountQty() {
    const response = await CommonGet('/api/VPUDashboard/GetYesterdayOrderCountQtywiseForVPUDashboard', null);
    return response.data;
}

async function GetTodayOrderCount() {
    const response = await CommonGet('/api/VPUDashboard/GetTodayOrderCountForVPUDashboard', null);
    return response.data;
}

async function GetReturnOrderCountToVPUDashboard() {
    const response = await CommonGet('/api/VPUDashboard/GetReturnOrderCountToVPUDashboard', null);
    return response.data;
}

async function GetDemandSKUwiseVPUDashboard() {
    const response = await CommonGet('/api/VPUDashboard/GetNoofProductsSKUYesterdayToVPUDashboard', null);
    return response.data;
}

async function GetSupplyVCCwiseVPUDashboard() {
    const response = await CommonGet('/api/VPUDashboard/GetSupplyfProductsVCCYesterdayToVPUDashboard', null);
    return response.data;
}


async function GetDemandVCCwiseVPUDashboard() {
    const response = await CommonGet('/api/VPUDashboard/GetTotalfProductsSKUYesterdayToVPUDashboard', null);
    return response.data;
}

async function GetSupplySKUwiseVPUDashboard() {
    const response = await CommonGet('/api/VPUDashboard/GetSupplyfProductsSKUYesterdayToVPUDashboard', null);
    return response.data;
}

